import React, { useEffect } from 'react';

function Notice() {

  useEffect(() => {
    $(window).trigger('scroll');
    $(window).scrollTop(0);
  }, []);

  return (
    <div id="container" className="cont_nt">
      <section className="section">
        <div className="inner">
          <div className="title-box">
            <h2 style = {{textAlign: 'center'}}>분할보고 공고</h2>
            <p style = {{textAlign: 'center'}}>
              당사는 2025년 09월 22일 주주총회 결의로 본 회사가 영위하는 사업 중 <br />글로벌서비스실(아웃소싱사업) 사업부문을 물적분할의 방법으로 분할하여 “투바이트 플레이 주식회사”를 설립하고, <br />본 회사는 존속할 것을 결의하고 상법 소정의 분할절차를 완료하였으므로<br /> 상법 제530조의11 및 동법 제527조 제4항에 의하여 분할보고총회에 갈음하여 이사회에서 <br />이 공고로서 분할보고를 갈음하고자 결의하였으므로 이에 분할완료 사실을 각 주주들께 이 공고로서 보고합니다.<br /><br />
            </p>
          </div>
          <div className="dl_box">
            <dl style = {{textAlign: 'center'}}>
              <dt>
                <br /><br />2025년 10월 01일
              </dt>

            </dl>

            <div style = {{textAlign: 'center'}}>
              <p className="footer-text-new" >
                <br />
                투바이트 주식회사<br />
                경기도 안양시 동안구 시민대로327번길 24, 5층(관양동)<br />
                대표이사  함 영 철<br />
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Notice;
